import { Box, Divider } from '@mui/material'
import { ReactNode } from 'react'

interface CreatePageProps {
  children: ReactNode
  color?: string
}

export const CreatePage = ({ children, color }: CreatePageProps) => {
  return (
    <Box
      sx={{
        mx: 4,
        my: 3,
        width: '90%',
      }}
    >
      <Divider color={color} sx={{ height: 6, width: '4rem' }} />
      {children}
    </Box>
  )
}
